"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import { CheckBadgeIcon } from "@heroicons/react/24/solid";
interface ProfilePreviewTooltipProps {
  avatarUrl: string;
  username: string;
  fullName?: string;
  postsCount?: number;
  followersCount: number; // The projected count for this date
  followingCount?: number;
  dateLabel: string;
  isVerified?: boolean;
  // New props for gain section
  dailyGain?: number;
  turboTotal?: number;
  showTurboUpsell?: boolean;
  entryType?: "today" | "projected";
}
function ProfilePreviewTooltip(t0) {
  const $ = _c(56);
  const {
    avatarUrl,
    username,
    fullName,
    postsCount,
    followersCount,
    followingCount,
    dateLabel,
    isVerified: t1,
    dailyGain,
    turboTotal,
    showTurboUpsell: t2,
    entryType
  } = t0;
  const isVerified = t1 === undefined ? false : t1;
  const showTurboUpsell = t2 === undefined ? false : t2;
  const formatNumber = _temp;
  let t3;
  if ($[0] !== dateLabel) {
    t3 = <p className="mb-2 text-xs font-medium text-gray-400">{dateLabel}</p>;
    $[0] = dateLabel;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== avatarUrl || $[3] !== username) {
    t4 = <img src={avatarUrl} alt={username} width={48} height={48} className="h-12 w-12 rounded-full bg-gray-100 object-cover" loading="eager" decoding="async" onError={_temp2} />;
    $[2] = avatarUrl;
    $[3] = username;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = fullName || username;
  let t6;
  if ($[5] !== t5) {
    t6 = <span className="truncate text-[15px] font-semibold text-gray-900">{t5}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isVerified) {
    t7 = isVerified && <CheckBadgeIcon className="h-4 w-4 flex-shrink-0 text-[#0095F6]" />;
    $[7] = isVerified;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className="flex items-center gap-1.5">{t6}{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== fullName || $[13] !== username) {
    t9 = fullName && <p className="truncate text-[13px] text-gray-500">@{username}</p>;
    $[12] = fullName;
    $[13] = username;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <div className="min-w-0 flex-1">{t8}{t9}</div>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t4) {
    t11 = <div className="flex items-center gap-3">{t4}{t10}</div>;
    $[18] = t10;
    $[19] = t4;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== postsCount) {
    t12 = formatNumber(postsCount);
    $[21] = postsCount;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <span className="text-[15px] font-bold tabular-nums text-gray-900">{t12}</span>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-xs font-medium text-gray-500">Posts</span>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13) {
    t15 = <div className="flex flex-col items-center">{t13}{t14}</div>;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== followersCount) {
    t16 = formatNumber(followersCount);
    $[28] = followersCount;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <span className="inline-flex items-center rounded-md bg-emerald-500 px-2 py-0.5 text-[15px] font-bold tabular-nums text-white">{t16}</span>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="mt-1 text-xs font-medium text-gray-500">Followers</span>;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17) {
    t19 = <div className="flex flex-col items-center">{t17}{t18}</div>;
    $[33] = t17;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== followingCount) {
    t20 = formatNumber(followingCount);
    $[35] = followingCount;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t20) {
    t21 = <span className="text-[15px] font-bold tabular-nums text-gray-900">{t20}</span>;
    $[37] = t20;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="text-xs font-medium text-gray-500">Following</span>;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t21) {
    t23 = <div className="flex flex-col items-center">{t21}{t22}</div>;
    $[40] = t21;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t15 || $[43] !== t19 || $[44] !== t23) {
    t24 = <div className="mt-3 flex items-center justify-between border-t border-gray-100 pt-3">{t15}{t19}{t23}</div>;
    $[42] = t15;
    $[43] = t19;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== dailyGain || $[47] !== entryType || $[48] !== showTurboUpsell || $[49] !== turboTotal) {
    t25 = dailyGain !== undefined && <div className="mt-3 border-t border-gray-100 pt-3"><p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">{entryType === "today" ? "Today's growth" : "Projected growth"}</p><p className="mt-0.5 text-[15px] font-bold text-emerald-600">+{dailyGain.toLocaleString()} followers</p>{showTurboUpsell && turboTotal !== undefined && turboTotal > dailyGain && <div className="mt-2.5 border-t border-gray-100 pt-2.5"><p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">With Glory</p><p className="mt-0.5 text-[15px] font-bold text-purple-600">+{turboTotal.toLocaleString()} followers/day</p></div>}</div>;
    $[46] = dailyGain;
    $[47] = entryType;
    $[48] = showTurboUpsell;
    $[49] = turboTotal;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t11 || $[52] !== t24 || $[53] !== t25 || $[54] !== t3) {
    t26 = <div className="w-[260px] rounded-xl border border-gray-200/80 bg-white px-4 py-3 shadow-xl shadow-black/10">{t3}{t11}{t24}{t25}</div>;
    $[51] = t11;
    $[52] = t24;
    $[53] = t25;
    $[54] = t3;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  return t26;
}
function _temp2(e) {
  (e.target as HTMLImageElement).src = "/img/default_avatar.jpeg";
}
function _temp(num) {
  if (num === undefined) {
    return "\u2014";
  }
  return num.toLocaleString();
}
export default memo(ProfilePreviewTooltip);